function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cloud-upload-outline",
  transform: "translate(-14.5 -62.29)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52325",
  "data-name": "Path 52325",
  d: "M59.953,107.743H70.941c7.952,0,14.458-4.223,14.458-12.087s-7.663-11.779-13.88-12.087C70.234,71.271,61.254,63.79,50.7,63.79A19.116,19.116,0,0,0,32.193,76.976C23.518,77.8,16,83.32,16,92.359s7.807,15.383,17.35,15.383h8.1",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52326",
  "data-name": "Path 52326",
  d: "M210.506,201.043l-9.253-9.253L192,201.043",
  transform: "translate(-150.554 -109.494)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_21",
  "data-name": "Line 21",
  y1: 34.76,
  transform: "translate(50.7 84.61)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

function SvgCloudUploadOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.399,
    height: 58.58,
    viewBox: "0 0 72.399 58.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadOutline);
export default __webpack_public_path__ + "static/media/cloud-upload-outline.e9137175.svg";
export { ForwardRef as ReactComponent };